import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import SiteBanner from "./SiteBanner";
import brandLogo from "../assets/images/bblg_logo.svg";

const navItems = [
  { to: "/offering", label: "Offering" },
  { to: "/work", label: "Track record" },
  { to: "/events", label: "Events" },
  { to: "/assessment", label: "Assessment" },
];

function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close the mobile menu on navigation. Scroll to the hash target if there is
  // one (e.g. /events#some-event), otherwise jump to the top of the page.
  useEffect(() => {
    setMenuOpen(false);

    if (location.hash) {
      const id = decodeURIComponent(location.hash.slice(1));
      // The target may render a tick after the route mounts.
      const raf = requestAnimationFrame(() => {
        const target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
      return () => cancelAnimationFrame(raf);
    }

    window.scrollTo({ top: 0, behavior: "auto" });
    return undefined;
  }, [location.pathname, location.hash]);

  return (
    <div className="site">
      <SiteBanner />
      <header className="site-header">
        <div className="site-header-inner">
          <Link to="/" className="site-brand" aria-label="Home">
            <img src={brandLogo} alt="BoldBrave and Logikfabriken" />
            <span className="site-brand-partner">Red Hat Partners</span>
          </Link>

          <button
            type="button"
            className="nav-toggle"
            aria-expanded={menuOpen}
            aria-controls="primary-nav"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="sr-only">Menu</span>
            <span className="nav-toggle-bars" aria-hidden="true" />
          </button>

          <nav
            id="primary-nav"
            className={`site-nav ${menuOpen ? "is-open" : ""}`}
            aria-label="Primary"
          >
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `site-nav-link ${isActive ? "is-active" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/contact" className="nav-cta">
              Talk to us
            </Link>
          </nav>
        </div>
      </header>

      <main className="site-main">
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="site-footer-inner">
          <div className="footer-brand">
            <p className="footer-kicker">Developer Platforms, delivered</p>
            <p className="footer-tag">
              We are Developers and DevEx leads who build Internal Developer
              Platforms for real, in production, at scale — with Red Hat.
            </p>
          </div>

          <div className="footer-cols">
            <nav className="footer-col" aria-label="Footer">
              <span className="footer-col-title">Explore</span>
              {navItems.map((item) => (
                <Link key={item.to} to={item.to} className="footer-link">
                  {item.label}
                </Link>
              ))}
              <Link to="/contact" className="footer-link">
                Talk to us
              </Link>
            </nav>

            <div className="footer-col">
              <span className="footer-col-title">Contact</span>
              <div className="footer-contact-person">
                <a
                  className="footer-link"
                  href="mailto:magnus@bold-n-brave.com"
                >
                  Magnus Christiansson · BoldBrave
                </a>
                <a className="footer-link footer-phone" href="tel:+46703122771">
                  +46 70 312 27 71
                </a>
              </div>
              <div className="footer-contact-person">
                <a
                  className="footer-link"
                  href="mailto:jesper@logikfabriken.se"
                >
                  Jesper Lindberg · Logikfabriken
                </a>
                <a className="footer-link footer-phone" href="tel:+46704016234">
                  +46 70 401 62 34
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-base">
          <span>BoldBrave AB · Logikfabriken AB · Red Hat partners</span>
          <Link className="footer-base-link" to="/privacy">
            Privacy policy
          </Link>
          <span>Copyright © {new Date().getFullYear()}</span>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
